// @flow
import createCustomTrackerSnippet from './radioAnalytics/snippets/customTrackerSnippet';
import createAudioVideoSnippet from './radioAnalytics/snippets/audioVideoSnippet';
import createjPlayerSnippet from './radioAnalytics/snippets/jPlayerSnippet';
import createMediaElementSnippet from './radioAnalytics/snippets/mediaElementSnippet';
import createExternalTrackerSnippet from './radioAnalytics/snippets/externalTrackerSnippet';
import createjwPlayerSnippet from './radioAnalytics/snippets/jwPlayerSnippet';

const installationSnippet =
  `(function (r, a, d, i, o) {
      r['RadioAnalytics'] = i;
      r[i] = r[i] || function () { (r[i].options = r[i].options || []).push(arguments); }; o = a.createElement("script");
      o.async = 1;
      o.src = d;
      var n = a.getElementsByTagName("script")[0];
      n.parentNode.insertBefore(o, n);
    })(window, document, "http://statsradio.com/js/RadioAnalytics.js?ts=" + new Date().getTime(), "ra");`;

export const radioAnalyticsInstallationSnippet =
  `<script>
  window.onload = function() {
    ${installationSnippet}
  };
</script>`;

export type SnippetPlayer = 'audio/video' | 'jwPlayer' | 'jPlayer' | 'mediaElement' | 'externalTracker' | 'custom';
export const SNIPPET_PLAYERS: SnippetPlayer[] = ['audio/video', 'jwPlayer', 'jPlayer', 'mediaElement', 'externalTracker', 'custom'];

const createSnippet = (body: string): string => {
  const snippet =
    `<script>
  window.onload = function() {
    ${installationSnippet}

    ${body}
  }
</script>`;

  return snippet;
};

export const createCompleteRadioAnalyticsInstallationSnippetFor = (callSign: string, player: SnippetPlayer) => {
  let body = '';

  if (player === 'custom') {
    body = createCustomTrackerSnippet(callSign);
  }

  if (player === 'audio/video') {
    body = createAudioVideoSnippet(callSign);
  }

  if (player === 'jPlayer') {
    body = createjPlayerSnippet(callSign);
  }

  if (player === 'mediaElement') {
    body = createMediaElementSnippet(callSign);
  }

  if (player === 'externalTracker') {
    body = createExternalTrackerSnippet(callSign);
  }

  if (player === 'jwPlayer') {
    body = createjwPlayerSnippet(callSign);
  }

  return createSnippet(body);
};



// WEBPACK FOOTER //
// ./src/statsradio/modules/radioConfiguration/content/radioAnalyticsSnippet.js